import { CSSProperties, FC, PropsWithChildren } from 'react';
import { CompanyLogoIcon } from 'assets/svg';

import * as S from './Layout.styled';

interface ILayoutProps extends PropsWithChildren {
  isLeftLogoHidden?: boolean;
  isLogoAnimated?: boolean;
  style?: CSSProperties;
}

export const Layout: FC<ILayoutProps> = ({
  isLeftLogoHidden = false,
  isLogoAnimated = false,
  style,
  children,
}) => {
  return (
    <S.Layout
      isLeftLogoHidden={isLeftLogoHidden}
      isLogoAnimated={isLogoAnimated}
      style={style}
    >
      <div className="layoutHeader">
        <CompanyLogoIcon className="layoutLogo" />
      </div>
      <div className="layoutContent">{children}</div>
    </S.Layout>
  );
};
